<script type="text/ecmascript-6">
    import DesignerQuestionSelectSideGlass from "../DesignerQuestionSelectSideGlass.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionSelectSideGlass,
            SynsealQuestion
        ],
    }
</script>
